export default {
	tenantId: "boc_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "boc--uat"
	}
}
